import { motion, useReducedMotion } from 'framer-motion';
import { claimMotion } from './motion';
import type { ClaimStepId } from './wizard';

const guidance: Record<ClaimStepId, { title: string; body: string; art?: string }> = {
  verify: { title: 'Start with your order', body: 'Use the email from checkout. Enshield connects your claim to the right purchase.', art: 'inspect' },
  items: { title: 'Just the items affected', body: 'Choose the items involved and check each quantity before continuing.' },
  details: { title: 'Tell us what happened', body: 'A clear description helps Enshield understand the delivery issue. Include the details you know.' },
  evidence: { title: 'A clearer picture helps', body: 'Keep the packaging if you can. Photos and documents can be added now or later through your private tracking link.', art: 'inspect' },
  review: { title: 'One final check', body: 'Review the order, items and description. You can go back to make changes before submitting.' },
  done: { title: 'Enshield has your claim', body: 'Your next step is to follow the private tracking link for updates. Submission does not mean approval; Enshield will review the details.', art: 'resolve' },
};

/** Reuses the approved family outside the form; never implies a claim decision. */
export function ClaimGuidance({ step, artworkBaseUrl }: { step: ClaimStepId; artworkBaseUrl?: string }) {
  const reduced = useReducedMotion() ?? false;
  const content = guidance[step];
  const showArt = !!content.art && artworkBaseUrl !== undefined;
  return <motion.aside
    key={step}
    className={`cw-guidance${showArt ? ' cw-guidance--illustrated' : ''}`}
    aria-label="Claim guidance"
    initial={reduced ? false : { opacity: 0 }}
    animate={{ opacity: 1 }}
    transition={{ duration: reduced ? 0 : claimMotion.duration.interface }}
  >
    {showArt ? <img src={`${artworkBaseUrl!.replace(/\/$/, '')}/media/astronaut/astronaut-${content.art}.png`} alt="" width={content.art === 'inspect' ? 520 : 436} height={content.art === 'inspect' ? 452 : 500} decoding="async" /> : null}
    <div><p className="cw-guidance__title">{content.title}</p><p className="cw-guidance__body">{content.body}</p></div>
  </motion.aside>;
}
